import { PageSubTitle, PageTitle } from "@/components/pageTitle";

export const Assist = () => {
  return (
    <div className="flex justify-center">
      <div className=" flex gap-[70px] pt-[192px] ">
        <div className="  w-[1920px] ">
          <PageTitle title="助力企业光速出海，成就全球无界时代" />
          <PageSubTitle title="Help enterprises go global" />
          <div className="w-[1920px] flex justify-between mt-[86px]">
            <Item
              img={"/imgs/about/1.png"}
              title="我们的愿景"
              content1="诚挚为您"
              content2="互联世界"
            />
            <Item
              img={"/imgs/about/2.png"}
              title="我们的使命"
              content1="助力企业光速出海"
              content2="成就全球无界时代"
            />
            <Item
              img={"/imgs/about/3.png"}
              title="我们的价值观"
              content1="诚挚服务，用心经营"
              content2="不断进取，灵活创新"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const Item = (props: {
  title: string;
  content1: string;
  content2: string;
  img: string;
}) => {
  return (
    <div className="w-[460px] h-[194px] bg-white shadow-[0px_4px_14px_0px_rgba(0,0,0,0.12)] rounded-[20px] pt-[30px] px-[20px] flex gap-[23px]">
      <div className="flex-1 ">
        <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[26px] text-[#333333]">
          {props.title}
        </div>
        <div className="mt-[30px]">
          <div className="flex items-center gap-[12px]">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_18031_7799)">
                <path
                  d="M0 12C0 5.37269 5.37269 0 12 0C18.6273 0 24 5.37269 24 12C24 18.6273 18.6273 24 12 24C5.37269 24 0 18.6273 0 12ZM9.82759 16.5617C9.97832 16.7171 10.184 16.8073 10.4004 16.8128C10.6168 16.8184 10.8269 16.7389 10.9854 16.5914L18.8491 9.28055C19.0087 9.13083 19.1024 8.92402 19.1099 8.70535C19.1174 8.48668 19.038 8.27394 18.889 8.11367C18.7401 7.9534 18.5337 7.85863 18.3151 7.8501C18.0964 7.84157 17.8833 7.91996 17.7223 8.06814L10.4772 14.8543L7.07586 11.347C7.00045 11.268 6.91012 11.2046 6.81009 11.1606C6.71007 11.1167 6.60232 11.0929 6.49308 11.0908C6.38383 11.0887 6.27525 11.1082 6.17359 11.1483C6.07193 11.1883 5.97921 11.2481 5.90078 11.3242C5.82235 11.4003 5.75977 11.4912 5.71663 11.5915C5.6735 11.6919 5.65068 11.7999 5.64947 11.9091C5.64827 12.0184 5.66872 12.1268 5.70964 12.2281C5.75055 12.3295 5.81113 12.4217 5.88786 12.4994L9.828 16.5617H9.82759Z"
                  fill="#74B9FF"
                />
              </g>
              <defs>
                <clipPath id="clip0_18031_7799">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-[#003366]">
              {props.content1}
            </div>
          </div>
          <div className="flex items-center gap-[12px]">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_18031_7799)">
                <path
                  d="M0 12C0 5.37269 5.37269 0 12 0C18.6273 0 24 5.37269 24 12C24 18.6273 18.6273 24 12 24C5.37269 24 0 18.6273 0 12ZM9.82759 16.5617C9.97832 16.7171 10.184 16.8073 10.4004 16.8128C10.6168 16.8184 10.8269 16.7389 10.9854 16.5914L18.8491 9.28055C19.0087 9.13083 19.1024 8.92402 19.1099 8.70535C19.1174 8.48668 19.038 8.27394 18.889 8.11367C18.7401 7.9534 18.5337 7.85863 18.3151 7.8501C18.0964 7.84157 17.8833 7.91996 17.7223 8.06814L10.4772 14.8543L7.07586 11.347C7.00045 11.268 6.91012 11.2046 6.81009 11.1606C6.71007 11.1167 6.60232 11.0929 6.49308 11.0908C6.38383 11.0887 6.27525 11.1082 6.17359 11.1483C6.07193 11.1883 5.97921 11.2481 5.90078 11.3242C5.82235 11.4003 5.75977 11.4912 5.71663 11.5915C5.6735 11.6919 5.65068 11.7999 5.64947 11.9091C5.64827 12.0184 5.66872 12.1268 5.70964 12.2281C5.75055 12.3295 5.81113 12.4217 5.88786 12.4994L9.828 16.5617H9.82759Z"
                  fill="#74B9FF"
                />
              </g>
              <defs>
                <clipPath id="clip0_18031_7799">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-[#003366]">
              {props.content2}
            </div>
          </div>
        </div>
      </div>
      <img className="w-[120px] h-[120px] " src={props.img} />
    </div>
  );
};
